import type { Alert } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  Label,
  Toggle,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEvent } from "react"
import { useCallback } from "react"

import styles from "./PhoneCallAlerts.module.scss"
import {
  usePolyglot,
  useFollowedUsers,
} from "src/contexts"
import { useInputPropsForValue } from "src/hooks"
import { followToSharer } from "src/utils"

const polyglotPrefix = "pages.alerts.phone_call.low_glucose_toggle."
const id = "low-glucose-call-active"

interface Props {
  belowNormalCall: Alert;
  updateAlert: (settings: Partial<Alert>) => void;
}

export function LowGlucoseToggle(props: Props) {
  const {
    belowNormalCall,
    updateAlert,
  } = props

  const { currentFollow } = useFollowedUsers()
  const polyglot = usePolyglot()

  const adapter = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => e.target.checked,
    [],
  )

  const onValueChange = useCallback(
    (isActive: Alert["is_active"]) => {
      updateAlert({
        is_active: isActive,
      })
    },
    [updateAlert],
  )

  const {
    value,
    onChange,
  } = useInputPropsForValue({
    value: belowNormalCall.is_active,
    onChange: onValueChange,
    adapter,
    updatedAt: belowNormalCall.updated_at,
  })

  return (
    <div className={styles.toggleContainer}>
      <div className={styles.toggleRow}>
        <Label
          htmlFor={id}
          id="low-glucose-call-active-label"
        >
          {polyglot.t(`${polyglotPrefix}label`)}
        </Label>
        <Toggle
          id={id}
          checked={!!value}
          onChange={onChange}
        />
      </div>
      <div className={styles.description}>
        {polyglot.t(
          `${polyglotPrefix}description_${value ? "active" : "inactive"}`,
          { user: followToSharer(currentFollow) },
        )}
      </div>
    </div>
  )
}
